const HEIGHT_MESSAGE_TYPE = 'hpa:calc:height';
const ALLOWED_ORIGINS = [
    'https://hpa-sam.github.io',
    'https://calculators.hpacademy.com'
];
const MIN_HEIGHT = 50;
const MAX_HEIGHT = 8000;

function findCalculatorFrame(source) {
    const frames = document.querySelectorAll('iframe[data-hpa-calc]');

    for (let i = 0; i < frames.length; i++) {
        if (frames[i].contentWindow === source) {
            return frames[i];
        }
    }

    return null;
}

function getReportedHeight(data) {
    if (!data || data.type !== HEIGHT_MESSAGE_TYPE) {
        return 0;
    }

    const height = parseInt(data.height, 10);

    if (!height || height < MIN_HEIGHT || height > MAX_HEIGHT) {
        return 0;
    }

    return height;
}

window.addEventListener('message', function(event) {
    if (ALLOWED_ORIGINS.indexOf(event.origin) === -1) {
        return;
    }

    const height = getReportedHeight(event.data);

    if (!height) {
        return;
    }

    const frame = findCalculatorFrame(event.source);

    if (frame) {
        frame.style.height = height + 'px';
    }
});



// WEBPACK FOOTER //
// ./js/modules/calculatorEmbed.js